export default "__VITE_ASSET__CnvO4kvU__"